// assets
import { IconFileDescription } from '@tabler/icons-react';
// constant
const icons = { IconFileDescription };
// ==============================|| APPLICATIONS MENU ITEMS ||============================== //
const applications = {
  id: 'applications',
  title: 'Applications',
  type: 'group',
  children: [
    {
      id: 'applications-list',
      title: 'Applications',
      type: 'item',
      url: '/applications/list',
      icon: icons.IconFileDescription,
      breadcrumbs: false
    }
  ]
};
export default applications;
